import React from 'react'

const Pill = ({status}:{status: string}) => {

  return (
    <div className={`pill ${status.toLowerCase()}`}>{status}</div>
  )
}

export default Pill